import { Injectable } from '@angular/core';
import {
    ContentService,
    Eula,
    EulaContent,
} from '@polaris-customerweb/sharedcomponents.shared';
import {
    UserProfile,
    UserProfileService,
} from '@polaris-customerweb/sharedcomponents.user-profile';
import { Observable, exhaustMap, map, of, tap } from 'rxjs';
import { UserAuthService } from '../state/user-auth/user-auth.service';

@Injectable({ providedIn: 'root' })
export class EulaService {
    private isEulaAccepted: boolean;

    constructor(
        private contentService: ContentService,
        private userAuthService: UserAuthService,
        private userProfileService: UserProfileService
    ) {}

    getEula(): Observable<Eula> {
        return this.contentService
            .getSingle<EulaContent>({ content_type: 'eula' })
            .pipe(map((contract) => new Eula(contract)));
    }

    acceptCurrentEula(): Observable<UserProfile | null> {
        return this.getCurrentEulaVersion().pipe(
            tap(() => (this.isEulaAccepted = true)),
            exhaustMap((eulaVersion) =>
                this.userProfileService.acceptEula$(eulaVersion)
            )
        );
    }

    declineCurrentEula(): void {
        this.isEulaAccepted = false;
    }

    isEulaConfirmCurrent(): Observable<boolean> {
        if (this.isEulaAccepted !== undefined) {
            return of(this.isEulaAccepted);
        }

        return this.userAuthService.isAuthenticated$.pipe(
            exhaustMap((isAuthenticated) => {
                if (!isAuthenticated) {
                    return of(true);
                }

                return this.getCurrentEulaVersion().pipe(
                    exhaustMap((eulaVersion) => {
                        if (!eulaVersion) {
                            return of(true);
                        }

                        return this.userProfileService.isEulaAccepted$(
                            eulaVersion
                        );
                    })
                );
            }),
            tap((isAccepted) => (this.isEulaAccepted = isAccepted))
        );
    }

    private getCurrentEulaVersion(): Observable<string> {
        return this.getEula().pipe(map((eula) => eula?.version ?? ''));
    }
}
